import { deleteLabelValue, localizeLabelCategory, localizeLabelValueName } from '@tableau/catalog-ui-temp';
import { restApiService } from '@tableau/vizportalclient-common-components';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { DeleteLabelValueAction } from '~src/catalog/actions/labelValues/DeleteLabelValueAction';
import { DeleteLabelValueWrapper, DeleteLabelValueWrapperProps } from '~src/catalog/components/labelValues/DeleteLabelValueWrapper';
import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

export function* handleDeleteLabelValue(action: DeleteLabelValueAction) {
  try {
      yield call(openDeleteLabelValueDialog, action);

      const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
      if (!maybeReloaded) {
        yield put(requestSpaceContents());
      }
  } catch(e) {
      yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openDeleteLabelValueDialog(action: DeleteLabelValueAction): Promise<unknown> {
  const labelValue = action.item;

  const dialogInstance = openReactActionDialog<DeleteLabelValueWrapperProps, void, IResult>({
    title: Messages.deleteLabelValueTitle({ CATEGORY: localizeLabelCategory(labelValue.category) }),
    actionName: Messages.deleteMessage(),
    action: makeDeleteCall,
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width375px,
    bodyComponent: DeleteLabelValueWrapper,
    initialBodyProps: { labelValue },
    initialDialogState: undefined,
    dismissDialogOnActionFailed: true,
    showCloseButton: true,
  });

  return dialogInstance.result;
}

async function makeDeleteCall(props: DeleteLabelValueWrapperProps): Promise<unknown> {
  const siteLuid = SessionSiteSelectors.siteLuid(getAppStore().getState());
  const {makeJsonRestApiRequest} = restApiService({siteLuid});
  const { labelValue } = props;

  return deleteLabelValue({
    makeJsonRestApiRequest
    },
    labelValue.value
    ).then(async (_: unknown) => {
      ToasterService.instance.pop({
        type: ToastType.Info,
        text: Messages.labelValueDeleteSuccess({
          CATEGORY: localizeLabelCategory(labelValue.category),
          NAME: localizeLabelValueName(labelValue.value),
        }),
      });
    })
    .catch((_: unknown) => ToasterService.instance.pop({
      type: ToastType.Error,
      text: Messages.labelValueDeleteError({
        CATEGORY: localizeLabelCategory(labelValue.category),
        NAME: localizeLabelValueName(labelValue.value),
      })
    }));
}

